import { useState } from 'react';
import {
  TestPanelContainer,
  PanelHeader,
  HeaderTop,
  Title,
  ToggleButton,
  PanelContent,
  AmountText,
  ApproveButton,
} from './PaymentTestPanel.styled';

interface PaymentTestPanelProps {
  onApprove: () => void;
  amount: number;
}

export const PaymentTestPanel = ({ onApprove, amount }: PaymentTestPanelProps) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!import.meta.env.DEV) return null;

  return (
    <TestPanelContainer>
      <PanelHeader>
        <HeaderTop>
          <Title>카드 결제 테스트 컴포넌트</Title>
          <ToggleButton onClick={() => setIsVisible(!isVisible)}>
            {isVisible ? '접기' : '펼치기'}
          </ToggleButton>
        </HeaderTop>
      </PanelHeader>

      {isVisible && (
        <PanelContent>
          <AmountText>결제 금액: {amount}원</AmountText>
          <ApproveButton onClick={onApprove}>결제 승인 처리</ApproveButton>
        </PanelContent>
      )}
    </TestPanelContainer>
  );
};
